import React from 'react';
import { message } from 'antd'; // Importing message from Ant Design
import "./UserAccount.css";

const UserAccount = ({ user = {}, onLogout, onClose, toggleAccount }) => {
  const handleLogout = () => {
    onLogout();  // Call the onLogout function passed as prop
  };

  return (
    <div className="user-account-card">
      <h3>User Profile</h3>
      <p><strong>Name:</strong> {user.name || 'N/A'}</p>
      <p><strong>Email:</strong> {user.email || 'N/A'}</p>
      <div className="userinfo-buttons">
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
        <button className="close-button1" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default UserAccount;
